module.exports = __webpack_public_path__ + "b895173b2ae3f1eb3a767afe3733b78a.pdf";